import React from 'react'
import {Typography,Button, Grid, TextField, MenuItem, Box, Link} from '@mui/material';
import colors from '../../../../colors'
import ButtonGroup from '../../../../general/ButtonGroup'
import {sendGeneralRequest} from '../../../../../features/generalRequest'
import { useSelector, useDispatch } from 'react-redux';
import { determineUtilityRequest } from '../DetermineUtilityRequest'
import { makeStyles } from '@mui/styles';
import { selectUserInfo } from '../../../../../features/userInfo/userInfoSlice';
import { selectUtilityState, setSentFrom, setExtraInvoiceListData } from '../../../../../features/utilities/utilitySlice';
import { selectMyContractsState, setShouldFillFields } from '../../../../../features/myContracts/myContractsSlice';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import { useNavigate } from 'react-router-dom';
import { texts } from '../../../../general/texts';

const Oshee = (props) => {

    const dispatch = useDispatch()
    const userInfo = useSelector(selectUserInfo)
    const utilitySliceState = useSelector(selectUtilityState)
    const myContractsSliceState = useSelector(selectMyContractsState)
    const navigate = useNavigate()
    
    const searchMethods = [
        { display: 'Kod Klienti', value: '2'},
        { display: 'Kontratë', value: '1'},
        //{ display: 'Nr. Serial', value:'3'}
        
    ]

    const typeMethod = [
        { display: 'Fature', value:'F'},
        { display: 'Aktmarrveshje', value:'A'}
    ]

    const [state, setState] = React.useState({
        utilityName: props.utilityName,
        token: props.globalDataSliceState.token,
        contractNo:'',
        instance: '',
        serie: '',
        type: typeMethod[0].value,
        searchMethod: searchMethods[0].value
    })

    const utilityRequest = determineUtilityRequest(state)

    const handleTextFieldChange = (prop) => (e) =>
    {
        setState({
            ...state,
            [prop]: e.target.value
        })
    } 

    const handleButtonClick = (sentFrom) => 
    {
        dispatch(setExtraInvoiceListData({type: state.type}))
        dispatch(utilityRequest)
        dispatch(setSentFrom(sentFrom))
    }

    const getSearchMethodValue = (value) => 
    {
        setState({...state, searchMethod: value})
    }

    const getTypeMethodValue = (value) => 
    {
        setState({...state, type: value})
    }

    const selectedButtonStyle =
    {
        backgroundColor: colors.lightOrange,
        color: colors.orange,
        width:'150px',
        height:'40px',
        fontFamily:'GerberaBold',
        textTransform:'none',
        fontSize:'1rem',
        border: '2px solid'+colors.orange,
        borderRadius:'10px',
        '&:hover': {
            backgroundColor: colors.lightOrange
        },
        '@media (max-width: 899px)' : {width:'130px', height:'40px'}                 
    }

    const defaultButtonStyle =
    {
        backgroundColor: colors.lightBlue,
        width:'150px',
        height:'40px',
        borderRadius:'10px',
        textTransform:'none',
        fontFamily:'GerberaLight',
        fontSize:'1rem',
        color: colors.darkBlue,
        '&:hover': {
            backgroundColor: colors.lightOrange
        },
        '@media (max-width: 899px)' : {width:'130px', height:'40px'}      
    }


    React.useEffect(()=>{
        if(myContractsSliceState.shouldFillFields)
        {
            setState({
                ...state,
                contractNo: props.selectedContractInfo.contract
            })
            dispatch(setShouldFillFields(false))
        }
    },[myContractsSliceState.shouldFillFields])

    React.useEffect(()=>{
        dispatch(sendGeneralRequest({request: {token: state.token}, baseUrlKey:'services', endpoint:'OSHEE/GetOSHEEInstaces'}))
    },[])

    const useStyles = makeStyles({
        mainGrid:{
            padding: '5%',
            paddingTop: '3%'
        },
        utilityName:{
            color:props.utilityInfo.Color,
            fontSize:'1.5rem',
            fontFamily:'GerberaBold',
            paddingTop:'3%',
            paddingLeft:'2%'
        },
        headerBox:{
            backgroundColor: colors.cyan,
            borderRadius:'100%',
            width:'70px',
            height:'70px'
        },
        fieldTitle:{
            color:colors.darkBlue,
            fontSize:'1.2rem',
            fontFamily:'GerberaBold',
            textAlign:'left'
        },
        button:{
            width:'100%',
            color:colors.white,
            fontSize:'1rem',
            textTransform:'none',
            background:colors.gradientOrange,
            fontFamily:'GerberaBold'
        },
        buttonGrid:{
            marginTop:15,
            paddingBottom: 5
        },
        image:{
            width:'65%',
        },
        textField:{
            width:'100%'
        }
    })

    const classes = useStyles()

    return(
        <Grid container item className={classes.mainGrid} rowSpacing={3}>
            <Grid container item md={2} xs={2} mt={2} ><Link component={'button'} onClick={()=> { navigate(-1)}}><ArrowBackIosNewIcon color='warning' /></Link></Grid>
            <Grid container item md={12} xs={12} >
                <Grid container direction="row" justifyContent="center" alignItems="center" className={classes.headerBox} ><img src={props.utilityInfo.Images.filter(image => image.color === 1 && image.size === 1)[0].imagePath} className={classes.image}/></Grid>
                <Typography className={classes.utilityName} >{props.utilityInfo.PublicName}</Typography>
            </Grid>
            <Grid container item md={12} rowSpacing={3}>
                <Grid container item md={12} >
                    <Typography className={classes.fieldTitle} >{texts["prompt-choose-search-method"]}</Typography>
                </Grid>
                <Grid container item md={12} xs={12} justifyContent='flex-start' columnSpacing={5} rowSpacing={3} >                           
                    <ButtonGroup defaultButtonStyle={defaultButtonStyle} selectedButtonStyle={selectedButtonStyle} state={searchMethods} sendValue={getSearchMethodValue}/>                                                                                                                                                                                                                                                                                                                                                                                                                                                                        
                </Grid>                            
                {state.searchMethod === '1' &&
                    <Grid container item rowSpacing={3} >
                        <Grid container item md={12} justifyContent='flex-start' >
                            <Typography className={classes.fieldTitle}>{texts["prompt-choose-city"]}</Typography>
                        </Grid>
                        <Grid container item md={12} justifyContent='flex-start' >
                            <TextField
                                select                              
                                label="Qyteti"
                                value={state.instance}
                                onChange={handleTextFieldChange('instance')}
                                color='warning'
                                size='small'
                                className={classes.textField}
                            >
                                {props.utilitySliceState.extraData.map((option) => (
                                    <MenuItem key={option.code} value={option.code}>
                                        {option.code}
                                    </MenuItem>
                                ))}                                                             
                            </TextField>
                        </Grid>
                        <Grid item md={12} xs={12} >
                            <Typography className={classes.fieldTitle}>{texts["placeholder-contract"]}</Typography>
                        </Grid>
                        <Grid item md={12} xs={12}  >
                            <TextField onChange={handleTextFieldChange('contractNo')} size='small' label={texts["placeholder-contract"]} color='warning' className={classes.textField}/>
                        </Grid>
                    </Grid>
                }
                {state.searchMethod === '2' &&
                <Grid container item rowSpacing={3} >
                    <Grid container item md={12} justifyContent='flex-start' >
                        <Typography className={classes.fieldTitle}>{texts["prompt-choose-contract-type"]}</Typography>
                    </Grid>
                    <Grid container item md={12} xs={12} justifyContent='flex-start' columnSpacing={5} rowSpacing={3} >                           
                        <ButtonGroup defaultButtonStyle={defaultButtonStyle} selectedButtonStyle={selectedButtonStyle} state={typeMethod} sendValue={getTypeMethodValue}/>                                                                                                                                                                                                                                                                                                                                                                                                                                                                        
                    </Grid>
                    <Grid item md={12} xs={12} >
                        <Typography className={classes.fieldTitle}>{texts["title-client-code"]}</Typography>
                    </Grid>
                    <Grid item md={12} xs={12}  >
                        <TextField onChange={handleTextFieldChange('contractNo')} value={state.contractNo} color='warning' size='small' label={texts["title-client-code"]} className={classes.textField}/>
                    </Grid>
                </Grid>
                }
                {/* {state.searchMethod === '3' &&
                    <Grid container item rowSpacing={3} >
                        <Grid container item md={12} xs={12} justifyContent='flex-start' >
                            <Typography className={classes.fieldTitle}>Numri serial</Typography>
                        </Grid>
                        <Grid item md={12} xs={12}  pb={'20%'} >
                            <TextField onChange={handleTextFieldChange('serie')} size='small' color='warning' label="Seriali" className={classes.textField}/>
                        </Grid>
                    </Grid>
                } */}
                <Grid item md={12} xs={12} className={classes.buttonGrid} >
                    <Button disabled={utilitySliceState.isLoading ? true : false} onClick={()=>{handleButtonClick('contractList')}} className={classes.button} >{texts["title-search"]}</Button>
                </Grid>
            </Grid>
                                                                                                                 
        </Grid>                                                  
    )
}
export default Oshee
